import { render, staticRenderFns } from "./ClassificacaoProcessoSelect.vue?vue&type=template&id=77bd782c"
import script from "./ClassificacaoProcessoSelect.vue?vue&type=script&lang=js"
export * from "./ClassificacaoProcessoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports